module.exports = __webpack_public_path__ + "img/refund.22ee1f0b.webp";